module.exports = __webpack_public_path__ + "img/cuffs_pl.da8dcb03.png";